import ColorfulBadge from './colorful-badge';
export default ColorfulBadge;
